import $ from 'jquery';
import Cookies from 'js-cookie';

const $cookiesEl = $('.cookies');
const $cookiesBar = $('.cookies__bar');
const cookiesModal = $('#cookies-modal');
const $cookiesConsent = $('.cookies-consent, .cookies-check-all');
const $cookiesConsentCustom = $('.cookies-consent-custom');
const $cookiesDecline = $('.cookies-decline');
const $checkboxes = $cookiesEl.find('.cookies__checkbox');

const $cookiesBarConsent = $('button.cookies-consent.cookies__button');
const $cookiesBarDecline = $('button.cookies-decline.cookies__button');
const $cookiesBarCustom = $('button.cookies__button.cookies__detail.modal-trigger');

const $cookiesModalConsent = $('button.cookies__button.cookies-check-all');
const $cookiesModalConsentCustom = $('button.cookies__button.cookies-consent-custom.modal-close');
const $cookiesModalClose = $('button.cookies__close.modal-close');
const $cookiesModalMore = $('a.cookies__button.cookies-more');

const $cookiesModalTrigger = $('button.modal-trigger.footer__misc-link');

const $body = $('body');

const cookiesExpiration = 120;

const acknowledgeCookies = (type = 'custom') => {
    let categories = [];

    switch (type) {
        case 'all':
            checkAll();
            break;
        case 'required':
            checkRequired();
            break;
        case 'custom':
            break;
    }

    $checkboxes
        .filter(function () {
            return $(this).is(':checked');
        })
        .each(function () {
            categories.push($(this).data('category'));
        });

    categories = categories.join(',');

    const cookie_cnsnt = Cookies.get('cookie_cnsnt');

    if (cookie_cnsnt === undefined || cookie_cnsnt != categories) {
        $cookiesBarConsent.trigger('focus');
        Cookies.set('cookie_cnsnt', categories, { expires: cookiesExpiration });
        initCookieFunctions();
    }
};

const initCookieFunctions = () => {
    const cookie_cnsnt = Cookies.get('cookie_cnsnt');

    if (cookie_cnsnt !== undefined) {
        if (SITE_PARAMS.user_is_admin) {
            console.log('Cookie init...' + cookie_cnsnt);
        }
        const categories = cookie_cnsnt.split(',');

        initGoogleAnalytics(categories.includes('analytics') ? 'granted' : 'denied');
    }
};

const initGoogleAnalytics = (mode = 'denied') => {
    if (SITE_PARAMS.user_is_admin) {
        console.log('GA ' + mode + '...');
    }
    gtag('consent', 'update', {
        analytics_storage: mode,
    });
};

const checkAll = () =>
    $checkboxes
        .filter(function () {
            return !$(this).is(':disabled');
        })
        .prop('checked', true);

const checkRequired = () =>
    $checkboxes
        .filter(function () {
            return !$(this).is(':disabled');
        })
        .prop('checked', false);

const checkSelected = categories =>
    $checkboxes
        .filter(function () {
            return !$(this).is(':disabled');
        })
        .each(function () {
            const $thisEl = $(this);
            $thisEl.prop('checked', categories.includes($thisEl.data('category')));
        });

const cookie_cnsnt = Cookies.get('cookie_cnsnt');

if (cookie_cnsnt === undefined) {
    $cookiesBar.slideUp(0).slideDown(500).addClass('cookies__bar--active');
    $cookiesBarConsent.trigger('focus');
} else {
    initCookieFunctions();
}

$cookiesConsent.on('click', () => {
    acknowledgeCookies('all');
    $cookiesBar.removeClass('cookies__bar--active').slideUp(300);
    $body.trigger('focus');
});
$cookiesDecline.on('click', () => {
    acknowledgeCookies('required');
    $cookiesBar.removeClass('cookies__bar--active').slideUp(300);
    $body.trigger('focus');
});
$cookiesConsentCustom.on('click', () => {
    acknowledgeCookies();
    $cookiesBar.removeClass('cookies__bar--active').slideUp(300);
    $body.trigger('focus');
});

cookiesModal.on('modal:opening modal:closing', () => {
    const cookie_cnsnt = Cookies.get('cookie_cnsnt');

    if (cookie_cnsnt !== undefined) {
        const categories = cookie_cnsnt.split(',');
        checkSelected(categories);
    } else {
        checkRequired();
    }
});

cookiesModal.on('modal:opening', () => {
    $cookiesModalConsent.trigger('focus');
});

cookiesModal.on('modal:closing', () => {
    if ($cookiesBar.hasClass('cookies__bar--active')) {
        $cookiesBarConsent.trigger('focus'); 
    } else {
        $body.trigger('focus'); 
    }
});

// cookies bar behaviour

$cookiesBarCustom.on('keydown', function (event) {
    if (event.shiftKey && event.key === 'Tab') {
        event.preventDefault();
        $cookiesBarDecline.trigger('focus');
    } else if (event.key === 'Tab') {
        event.preventDefault();
        $cookiesBarConsent.trigger('focus');
    }
});

$cookiesBarConsent.on('keydown', function (event) {
    if (event.shiftKey && event.key === 'Tab') {
        event.preventDefault();
        $cookiesBarCustom.trigger('focus');
    } else if (event.key === 'Tab') {
        event.preventDefault();
        $cookiesBarDecline.trigger('focus');
    }
});

// cookies modal behaviour

$cookiesModalMore.on('keydown', function (event) {
    if (event.shiftKey && event.key === 'Tab') {
        event.preventDefault();
        $cookiesModalConsentCustom.trigger('focus');
    } else if (event.key === 'Tab') {
        event.preventDefault();
        $cookiesModalClose.trigger('focus');
    }
});

$cookiesModalClose.on('keydown', function (event) {
    if (event.shiftKey && event.key === 'Tab') {
        event.preventDefault();
        $cookiesModalMore.trigger('focus');
    }
});

$cookiesModalConsent.on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
        $(this).trigger('focus');
    }
});

// cookies modal trigger behaviour 

$cookiesModalTrigger.on('keydown', function (event) {
    if (event.key === 'Tab') {
        event.preventDefault();
        $body.trigger('focus');
    } 
});


